export default (name: string, platform: string): boolean =>
  ['responsive', 'progressive'].includes(platform) && name === 'Most Popular widget';
